export class BankAcc {
  public BankName: string;
  public AccountHolderName: string;
  public AccountNickname: string;
  public AccountNumber: string;
  public RoutingNumber: string;
  public AccountType: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public Country: string;
  public BAID: string;
  public ActualACNumber: string;
  public ActualRoutingNumber: string;
}



// WEBPACK FOOTER //
// ./src/app/models/BankAcc.ts